import script from "./DeviceCodePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceCodePage.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceCodePage.vue?vue&type=style&index=0&id=5be5973d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be5973d"]])

export default __exports__